import React, { useState } from "react";
import { Link } from "react-router-dom";
import Ads from "./Adds";
import Users from "./Users";
import Category from "./Category";
import Profile from "./AdminProfile";
import MainDashboard from "./Homedash";
import {  FaTags } from "react-icons/fa";


function Dashboard() {
  const [activePage, setActivePage] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const renderActivePage = () => {
    switch (activePage) {
      case "/dashboard":
        return <MainDashboard />;
      case "/users":
        return <Users />;
      case "/Ads":
        return <Ads />;
      case "/category":
        return <Category />;
      case "/profile":
        return <Profile />;
      default:
        return <MainDashboard />;
    }
  };

  const getButtonClasses = (page) => {
    return `flex items-center p-4 text-gray-600 hover:border-b-2 hover:font-bold hover:text-primary/90 gap-2 w-[200px] rounded ${
      activePage === page ? "text-primary font-bold" : ""
    }`;
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      {isSidebarOpen && (
        <div className="w-64 bg-white shadow-md ">
          <div className="p-4">
            <div className="flex items-center justify-between">
              <Link to="/">
                <h2 className="text-xl font-semibold">Admin Dashboard</h2>
              </Link>
              <i
                className="fa fa-times cursor-pointer text-[20px]"
                onClick={() => setIsSidebarOpen(false)}
              ></i>
            </div>
            <div className="pt-10">
              <button
                onClick={() => setActivePage("/dashboard")}
                className={getButtonClasses("/dashboard")}
              >
                <i className="fa fa-tachometer-alt mr-2"></i> Dashboard
              </button>
              <button
                onClick={() => setActivePage("/Ads")}
                className={getButtonClasses("/Ads")}
              >
               <FaTags/> Ads
              </button>
              <button
                onClick={() => setActivePage("/category")}
                className={getButtonClasses("/category")}
              >
                <i className="fa fa-list-alt mr-2"></i> Category
              </button>
              <button
                onClick={() => setActivePage("/users")}
                className={getButtonClasses("/users")}
              >
                <i className="fa fa-users mr-2"></i> Users
              </button>
              <button
                onClick={() => setActivePage("/profile")}
                className={getButtonClasses("/profile")}
              >
                <i className="fa fa-user mr-2"></i> Profile
              </button>
              {/* //Logout */}
              <button className="flex items-center p-4 text-gray-600 hover:border-b-2 hover:font-bold hover:text-red-600 gap-2 w-[200px] rounded">
                <i className="fa fa-sign-out-alt mr-2"></i> Logout
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col">
        {/* Top Bar */}
        <header className="flex items-center justify-between p-4 bg-white shadow-md  ">
          <div className="flex items-center ">
            {!isSidebarOpen && (
              <i
                className="fa fa-bars cursor-pointer mr-4 text-[20px]"
                onClick={() => setIsSidebarOpen(true)}
              ></i>
            )}
            <h1 className="text-2xl font-bold">Jathusan</h1>
          </div>
          <div className="flex items-center justify-between gap-4">
            <div className="relative hidden md:block lg:block">
              <i
                className="fa fa-search absolute left-3 top-1/2 transform -translate-y-1/2"
                aria-hidden="true"
              ></i>
              <input
                type="search"
                placeholder="Search"
                className="w-[350px] py-2 pl-10 border rounded focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>
            <div
              className="Notification cursor-pointer"
              onClick={() => setActivePage("/Ads")}
            >
              <i className="fa fa-bell text-[20px]" aria-hidden="true"></i>
            </div>
            <div className="Userprofile">
              <img
                src="http://www.gravatar.com/avatar/?d=mp"
                alt="Profile"
                className="w-10 h-10 rounded-full cursor-pointer"
                onClick={() => setActivePage("/profile")}
              />
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 p-6 bg-gray-50">{renderActivePage()}</main>
      </div>
    </div>
  );
}

export default Dashboard;
